import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'translation'

import CloseIcon from '../../assets/icons/close_2.svg'
import CheckIcon from '../../assets/icons/check.svg'
import PlusIcon from '../../assets/icons/plus.svg'

const SettingsSaveFilesSongItem = ({
  artist,
  genreName,
  title,
  imageUrl,
  selectSongHandler,
  selected,
  downloaded,
  deleteDownloadHandler,
}) => (
  // Note: component reused from alarm submenu, so many of the same classes prefixed with 'alarm_...' are reused
  <li className="alarm_block_list_item">
    {downloaded ? (
      <div className="alarm_block preview_mod song_btn_mod downloaded_song_mod">
        <button className="alarm_block_remove" onClick={deleteDownloadHandler}>
          <CloseIcon className="icon close_mod size_mod" />
        </button>
        <div className="save_files_block_downloaded">
          <CheckIcon className="icon close_mod size_mod" />
        </div>
        <div className="alarm_block_w_img">
          <img
            className="alarm_block_img"
            src={imageUrl}
            alt={`${title} ${t('alarm.BY')} ${artist}`}
          />
        </div>
        <div className={`alarm_block_descr ${downloaded ? 'selected' : ''}`}>
          <div className="alarm_block_category">{genreName.toUpperCase()}</div>
          <div className="alarm_block_name">{title}</div>
          <div className="alarm_block_artist">{artist}</div>
        </div>
      </div>
    ) : (
      <button
        className="alarm_block preview_mod song_btn_mod"
        onClick={selectSongHandler}
      >
        <div className="save_files_add_remove">
          {selected ? (
            <CloseIcon className="icon close_mod size_mod" />
          ) : (
            <PlusIcon className="icon close_mod size_mod" />
          )}
        </div>
        <div className="alarm_block_w_img">
          <img
            className="alarm_block_img"
            src={imageUrl}
            alt={`${title} ${t('alarm.BY')} ${artist}`}
          />
        </div>
        <div className={`alarm_block_descr ${selected ? 'selected' : ''}`}>
          <div className="alarm_block_category">{genreName.toUpperCase()}</div>
          <div className="alarm_block_name">{title}</div>
          <div className="alarm_block_artist">{artist}</div>
        </div>
      </button>
    )}
  </li>
)

export default SettingsSaveFilesSongItem

SettingsSaveFilesSongItem.propTypes = {
  artist: PropTypes.string.isRequired,
  genreName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  selectSongHandler: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  downloaded: PropTypes.bool.isRequired,
  deleteDownloadHandler: PropTypes.func.isRequired,
}
